










import { Component, Vue } from 'vue-property-decorator';
import ProductGroupForm from '@/components/ProductGroup/ProductGroupForm.vue';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit } from '@/queries/__generated__/currentUnit';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_ProductGroupCreate } from '@/queries/global';
import gql from 'graphql-tag';

const CREATE_PRODUCT_GROUP = gql`
  mutation createProductGroup($productGroup: ProductGroupCreate!) {
    createProductGroup(input: { productGroup: $productGroup }) {
      productGroup {
        id
        name
        description
        fullPathName
        parentGroup {
          id
          fullPathName
        }
      }
    }
  },
`;

@Component({
  components: {
    ProductGroupForm,
  },
})
export default class ProductGroupNew extends Vue {
  @SmartQuery<ProductGroupNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data.unitId = data.currentUnit.id;
    },
  }) private currentUnit!: GQL_currentUnit;

  private CREATE_PRODUCT_GROUP = CREATE_PRODUCT_GROUP;

  private data: GQL_ProductGroupCreate = {
    name: '',
    description: null,
    unitId: '',
    parentGroupId: null,
  };

  public formatForMutation(productGroup: GQL_ProductGroupCreate): GQL_ProductGroupCreate {
    return {
      unitId: productGroup.unitId,
      name: productGroup.name,
      description: productGroup.description,
      parentGroupId: productGroup.parentGroupId,
    };
  }
}
